import { Slide } from "react-reveal";
import t from "assets/videos/animated_2.gif";

const RoadMAP = () => {
    const dataArray = [
        {
            percent: '10%',
            title: "THE BEGINNING",
            bodyText: <>
                <p>To us, the community comes first. The goal is to make our drop the most successful it can be and ensure Meta Masks can reach new heights and new opportunities than any other project.</p>
                <p>We will announce our drop release date once we are satisfied with the project’s quality and technical parts. We will also be working tirelessly with our community to guarantee our social media platforms are at a high aesthetic standard and create new concepts over time.</p>
            </>
        },
        {
            percent: '20%',
            title: "THE EXPANSION",
            bodyText: <>
                <p>The Meta Masks break the news. We are expanding to the wider community through our contracts with supreme agencies and major PR agencies from New York which will help us gain exposure and online public relation articles. This will help us spread the word of the Meta Masks society and create your virtual identity in the most unique aesthetic ways providing our community with individuality and wealth.</p>
            </>
        },
        {
            percent: '40%',
            title: "THE SIMULATION",
            bodyText: <>
                <p>Join the discord and whitelist and be rewarded for helping the community grow! There will be multiple rewards for both the verified discord and whitelist members including: 1 of 1 ultra rare Meta Masks, exclusive access to huge celebrity meta concerts, $20,000 of ETH & much more!</p>
                <p>Meta Masks has teamed up with a major Masked influencer to which will reveal their identity for a HUGE announcement and giveaway. - Major influencer reveal</p>
            </>
        },
        {
            percent: '60%',
            title: "THE DISTRIBUTION",
            bodyText: <>
                <p>The community has taken part in not only owning the best most valued NFT on the market but in turn helping a great cause which is giving back to a major charity which will be revealed after launch date sell out alongside %10 of royalties being given back to the community.</p>
                <p>Holders will not only own a rapidly growing investment & unique meta identity. Upon holding 3 or more Meta Masks you will be in the draw to win a major prize</p>
            </>
        },
        {
            percent: '80%',
            title: "THE META INTEGRATION",
            bodyText: <>
                <p>Meta Masks will begin integration into numerous play to earn gaming & virtual experience platforms already under contract.</p>
            </>
        },
        {
            percent: '90%',
            title: "THE VERIFICATION",
            bodyText: <>
                <p>Get Meta Masks collection verified on OpenSea.io. Work begins on Meta Masks 3D collection, each holder of Meta Masks 2D collection will go into a raffle to win a rare 3D Meta Mask NFT to which will come with a prize of 2 Ethereum</p>
            </>
        },
        {
            percent: '100%',
            title: "THE META MASKS FUTURE",
            bodyText: <>
                <p>Upon selling out the public mint, the Meta Masks team will invest AGAIN, just as you have. A further $500,000 will be put all aspects of the project; Gaming collaborations, virtual concerts & parties, Huge giveaways, celebrity partnerships and staking returns for Meta Masks holders.</p>
            </>
        }
    ];
    return (
        <section id="roadmap">
              <img className="animated_assets" src={t} alt="" />
            <div className="sec-heading-wrapper">
                <Slide bottom> <h1 className="sec-heading">Roadmap</h1></Slide>
            </div>
            <div className="decal container">
                <div className="middle row relative">
                    <div className="timeline column">
                        <div className="line">
                            <div className="progression"></div>
                        </div>
                        {dataArray.map((data, index) => {
                            return (
                                <div className={`step row ${index === 0 ? 'done' : ''}`}>
                                    <Slide key={index} top>
                                        <div className="dot">
                                            <div className="shape"></div>
                                        </div>
                                    </Slide>
                                    <Slide key={index} bottom>
                                        <div  className="details">
                                            <div className="title row">
                                                <div className="number degrade">{data.percent}</div>
                                                <h3>{data.title}</h3>
                                            </div>
                                            {data.bodyText}
                                        </div>
                                    </Slide>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    )
};





export default RoadMAP
